import React, { useState, FunctionComponent } from 'react';

import { Modal } from 'components';
import { Button, Heading, Icon } from 'components/chroma';

import { Extra } from 'scenes/common/types';

import {
  ImageMenuWrapper,
  ButtonWrapper,
  OptionalExtraImage,
  OptionInformationWrapper,
} from './wrappers';

interface ModalProps {
  optionalExtras: Extra[];
  isOpen: boolean;
  onClose: () => void;
}

const imageMenuItems = (
  availableExtras: Extra[],
  menuSelection: Extra,
  setMenuSelection: React.Dispatch<Extra>
) =>
  availableExtras.map((item) => {
    const isSelected =
      availableExtras.length > 1 && menuSelection.code === item.code;
    return (
      <ButtonWrapper
        key={item.label}
        unselected={menuSelection.code !== item.code}
      >
        <Button
          ariaLabel={item.label}
          ariaExpanded={String(isSelected)}
          tertiary
          onClick={() => setMenuSelection(item)}
        >
          <OptionalExtraImage src={item.image} alt={item.label} />
        </Button>
        {isSelected && <Icon name="chevronDown" />}
      </ButtonWrapper>
    );
  });

const FindOutMoreModal: FunctionComponent<ModalProps> = ({
  optionalExtras,
  isOpen,
  onClose,
}) => {
  const [menuSelection, setMenuSelection] = useState(optionalExtras[0]);

  return (
    <Modal header="Optional extras" isOpen={isOpen} onClose={onClose}>
      <ImageMenuWrapper singleItem={optionalExtras.length === 1}>
        {imageMenuItems(optionalExtras, menuSelection, setMenuSelection)}
      </ImageMenuWrapper>
      <OptionInformationWrapper aria-label={`${menuSelection.code}_heading`}>
        <Heading size={2} margin={{ bottom: 1 }}>
          {menuSelection.label}
        </Heading>
        <menuSelection.content />
      </OptionInformationWrapper>
    </Modal>
  );
};

export default FindOutMoreModal;
